// extracted by mini-css-extract-plugin
export var deleteIcon = "_pq-5";
export var deleteOption = "_pq-3";
export var divider = "_pq-2";
export var downloadIcon = "_pq-4";
export var drawer = "_pq-0";
export var drawerFooter = "_pq-6";
export var drawerOpen = "_pq-1";
export var highlighted = "_pq-7";
export var lighterHighlight = "_pq-8";